<template>
  <div class="auth-wrapper auth-v2">
    <div class="auth-inner">
      <v-row class="auth-row ma-0">
        <v-col
          lg="7"
          class="d-none d-lg-block position-relative overflow-hidden pa-0"
        >
          <div class="auth-illustrator-wrapper">
            <!-- 3d character -->
            <div class="d-flex align-center h-full pa-16 pe-0">
              <v-img
                contain
                max-width="630"
                class="auth-3d-group  ma-auto"
                :src="require(`@/assets/images/nitron.jpg`)"
              ></v-img>
            </div>
          </div>
        </v-col>

        <v-col
          lg="5"
          style="height: 100vh ; overflow: auto"
          class="d-flex align-center auth-bg pa-10 pb-0 pt-0"
        >
          <v-row>
            <v-col
              cols="12"
              sm="8"
              md="6"
              lg="12"
              class="mx-auto"
            >
              <v-card flat>
                <!-- login form -->
                <v-card-text>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="12" lg="12" xl="12" md="12" sm="12" style="text-align: center">
                        <!-- brand logo -->
                        <v-img
                          :src="appLogo"
                          max-height="77px"
                          max-width="150px"
                          alt="logo"
                          class="ma-auto"
                        ></v-img>
                        <!--/ brand logo -->
                      </v-col>
                    </v-row>
                  </v-container>
                  <v-form
                    ref="loginForm"
                    v-model="loginValidation"
                    autocomplete="off"
                    @submit.prevent="login"
                  >
                    <v-text-field
                      v-model="phoneEmail"
                      dense
                      autocomplete="off"
                      outlined
                      label="شماره تلفن همراه "
                      placeholder="شماره تلفن همراه "
                      hide-details="auto"
                      :rules="[v => !!v || 'لطفا شماره همراه خود را وارد نمایید.' , v => (v && v.length >= 13) || 'شماره همراه را مانند 6789 345 0912  وارد نمایید']"
                      class="mb-2 phoneThings"
                      v-mask="'09## ### ####'"
                    ></v-text-field>

                    <v-text-field
                      v-model="password"
                      dense
                      outlined
                      :type="isPasswordVisible ? 'text' : 'password'"
                      label="رمز عبور"
                      placeholder="رمز عبور"
                      :rules="[v => !!v || 'لطفا رمز عبور خود را وارد نمایید.', v => (v && v.length >= 8) || 'لطفا بیشتر از 8 حرف وارد نمایید.']"
                      :append-icon="isPasswordVisible ? icons.mdiEyeOffOutline:icons.mdiEyeOutline"
                      hide-details="auto"
                      class="mb-0"
                      @click:append="isPasswordVisible = !isPasswordVisible"
                    ></v-text-field>


                    <v-btn
                      :disabled="!loginValidation"
                      block
                      dense
                      color="primary"
                      type="submit"
                      class="mt-2"
                    >
                      ورود به حساب کاربری
                    </v-btn>
                    <router-link
                      to="forgotPassword"
                      class="ms-3 pt-3 pb-3 float-right"
                    >
                      رمز عبور  خود را فراموش کرده ام!
                    </router-link>
                  </v-form>
                </v-card-text>

                <!-- create new account  -->
                <v-card-text class="d-flex align-center justify-center flex-wrap mt-0">
                  <p class="mb-0 me-2">
                    پس از تایید توسط مدیر سامانه حساب فعال میشود
                  </p>
                  <router-link to="register">
                    ایجاد حساب کاربری جدید
                  </router-link>
                </v-card-text>

                <!-- divider -->
                <v-card-text class="d-flex align-center mt-0">
                  <v-divider></v-divider>
                  <span class="mx-5 mt-0">راه های ارتباطی</span>
                  <v-divider></v-divider>
                </v-card-text>

                <!-- socail links -->
                <v-card-actions class="d-flex justify-center">
                  <v-tooltip bottom v-for="link in socialLink" :key="link.icon">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        class="ms-1 mt-0"
                        :href="link.link"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon :color="$vuetify.theme.dark ? link.colorInDark:link.color">
                          {{ link.icon }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ link.tooltip }}</span>
                  </v-tooltip>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import {
  mdiEyeOutline,
  mdiEyeOffOutline, mdiTelegram, mdiInstagram, mdiPhone
} from '@mdi/js'
import axios from '@axios'
import themeConfig from '@themeConfig'
import { mask } from 'vue-the-mask'
import baseConfig from '@/../baseConfig'
import router from '@/router'

import {removeCharFromString}
  from "@/views/generator/page-handler";

export default {
  directives: { mask },
  data() {
    return {
      loginValidation : false,
      phoneEmail: "",
      password: "",
      isPasswordVisible: false,
      alert: false,
      icons: {
        mdiEyeOutline,
        mdiEyeOffOutline,
      },
      appName: themeConfig.app.name,
      appLogo: themeConfig.app.logo,
      socialLink: [
        {
          icon: mdiTelegram,
          color: '#4267b2',
          colorInDark: '#4267b2',
          link: 'tg://resolve?domain=mevarizi',
          tooltip: 'کانال اطلاع رسانی',
        },
        {
          icon: mdiTelegram,
          color: '#b424d4',
          colorInDark: '#ba0c9d',
          link: 'tg://resolve?domain=adham54470',
          tooltip: 'ارتباط با مدیریت',
        },
        {
          icon: mdiTelegram,
          color: '#24d42d',
          colorInDark: '#078a23',
          link: 'tg://resolve?domain=Ssupportvarizi',
          tooltip: 'واحد پشتیبانی',
        },
        {
          icon: mdiPhone,
          color: '#24d473',
          colorInDark: '#078a56',
          link: 'tel:5554280940',
          tooltip: 'شماره تماس: 34935-013',
        },
        {
          icon: mdiPhone,
          color: '#511e8c',
          colorInDark: '#3a1064',
          link: 'tel:09115230700',
          tooltip: 'شماره تماس: 09115230700',
        },
        {
          icon: mdiPhone,
          color: '#511e8c',
          colorInDark: '#3a1064',
          link: 'tel:09115230700',
          tooltip: 'شماره تماس: 09117220700',
        },
      ],
    }
  },
  methods: {
    login() {
      if (this.loginValidation){
        axios.post(baseConfig.baseUrl +'login', {
          phoneEmail: removeCharFromString(this.phoneEmail, ' '),
          password: this.password,
        })
          .then(response => {
            if(response.data.status==="success"){
              const {token} = response.data.data
              window.sessionStorage.setItem("login","yes")
              // console.log(response.data.data.user.currentOrganizationId);
              //  alert(response.data.data.user.currentOrganizationId)
              localStorage.setItem('firstName', response.data.data.user.firstName)
              localStorage.setItem('lastName', response.data.data.user.lastName)
              localStorage.setItem('currentOrganizationId', response.data.data.user.defaultOrganizationId)
              this.$store.dispatch("user/setUser",response.data.data)
              localStorage.setItem('currentOrganizationId', response.data.data.user.defaultOrganizationId)
              localStorage.setItem('accessToken', token)
              router.push('/')
            }else{
              alert("شماره همراه یا رمز عبور نا معتبر است")
            }
          })
      }else {
        this.$refs.loginForm.validate()
        this.alert=true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@core/preset/preset/pages/auth.scss';
div.d-flex:nth-child(1){
  background-color: #28243d;
}
html{
  min-height: 100%;
  position: fixed;
  min-width: 100%;
  background-color: #28243d !important;
}

</style>
<style>
.phoneThings input{
  direction: ltr !important;
}
</style>
